module.exports = __webpack_public_path__ + "static/media/check.36457798.svg";